import axios from 'axios'
import { FileResponse } from '../../../../api/models'

const baseUrl = process.env.REACT_APP_API_URL

// eslint-disable-next-line import/prefer-default-export
export async function deleteDocumentV2(id: number) {
  await axios.delete<void>(`${baseUrl}/v2/document/${id}`)
}

export async function postFileV2(formData: FormData) {
  const { data } = await axios.post<FileResponse>(`${baseUrl}/v2/document-file`, formData)

  return data
}

export async function deleteFileV2(folder: string, fileUuid: string) {
  await axios.delete<FileResponse>(`${baseUrl}/v2/document-file/${folder}/${fileUuid}`)
}
